import { EventLiveStreamApiService } from "@api-services/platform/EventLiveStreamApiService";
import { LiveStreamResponse } from "@api-types/event/LiveStreamResponse";

export class EventLiveStreamService {
	static async getLiveStreamUrl(
		eventId: string
	): Promise<LiveStreamResponse> {
		try {
			return await EventLiveStreamApiService.getStreamUrl(eventId);
		} catch (error) {
			console.error(error);
			throw "LIVE_WIDGETS.LIVE_STREAM.STREAM_UNAVAILABLE";
		}
	}
}
